import { useTogglePreview } from 'src/hooks';
import { FileTypeEnum, FileType } from 'src/types';

export const useMediaGridItem = (data: FileType) => {
  const { togglePreview } = useTogglePreview();

  const isVideo = data.type === FileTypeEnum.Video;

  const handleClick = () => togglePreview();

  return {
    isVideo,
    handleClick,
  };
};
